import '../styles/top_section.css';
function TopSection(props) {

    return (
      <section className="packages_hero"  style={{ backgroundImage: `url(${props.image})`,backgroundPositionY: props.backgroundPositionY,
       backgroundSize: (props.backgroundSize? props.backgroundSize:"cover" )}}>
        <div className="over_lay"></div>
        <div className="text_container px-3">
          <div className='top_text'>Home | {props.text}</div>
          <h1>{props.text}</h1>
        </div>
      </section>
    );
}

export default TopSection;